import { render, staticRenderFns } from "./ArticlePreviewBlock.vue?vue&type=template&id=2c06b64a&scoped=true&"
import script from "./ArticlePreviewBlock.vue?vue&type=script&lang=js&"
export * from "./ArticlePreviewBlock.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePreviewBlock.vue?vue&type=style&index=0&id=2c06b64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06b64a",
  null
  
)

export default component.exports